export default "__VITE_ASSET__B9Ib5pgX__"